import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { useRef } from "react";
import { PanelBoundary } from "../components/PanelBoundary";
import { RightToolbarLayout } from "../components/right_toolbar/rightToolbar";
import { FileUploadProvider } from "../hooks/useFileUpload";
import { ThreadProvider } from "../hooks/useThread";
import { PanelType, Thread } from "../types";
import styles from "./style.module.css";
import { ThreadContents } from "./ThreadContents";
import { PanelRefs, ThreadDetailsPanel } from "./ThreadDetailsPanel";

export function ThreadContentsContainer({ thread }: { thread: Thread }) {
  const panelRefs: PanelRefs = {
    data: useRef<HTMLDivElement>(null),
    user: useRef<HTMLDivElement>(null),
    accounts: useRef<HTMLDivElement>(null),
    messages: useRef<HTMLDivElement>(null),
    notes: useRef<HTMLDivElement>(null),
  };

  const scrollToPanel = (panel: PanelType) => {
    panelRefs[panel].current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const { permissions } = useUserConfiguration();

  return (
    <div key={thread.id} className={styles.pageWrapper}>
      <div className={styles.threadLayout}>
        <div className={`${styles.threadContentsCard} bgColor--white padding--all rounded--all`}>
          <PanelBoundary label="this conversation">
            <FileUploadProvider key={thread.id}>
              <ThreadProvider thread={thread} key={thread.id}>
                <ThreadContents />
              </ThreadProvider>
            </FileUploadProvider>
          </PanelBoundary>
        </div>
        <div
          className={`${styles.threadDetailsPanelCard} bgColor--white padding--all rounded--all`}
        >
          <ThreadDetailsPanel thread={thread} panelRefs={panelRefs} />
        </div>
      </div>
      <RightToolbarLayout>
        <RightToolbarLayout.Toolbar>
          <RightToolbarLayout.ToolbarButton
            label="Data"
            iconName="list"
            onClick={() => scrollToPanel("data")}
          />
          <RightToolbarLayout.ToolbarButton
            label="User information"
            iconName="user"
            onClick={() => scrollToPanel("user")}
          />
          {permissions.includes("indigo.view_account") && (
            <RightToolbarLayout.ToolbarButton
              label="Accounts"
              iconName="bank"
              onClick={() => scrollToPanel("accounts")}
            />
          )}
          <RightToolbarLayout.ToolbarButton
            label="Recent messages"
            iconName="message-square"
            onClick={() => scrollToPanel("messages")}
          />
          <RightToolbarLayout.ToolbarButton
            label="Notes"
            iconName="edit-3"
            onClick={() => scrollToPanel("notes")}
          />
        </RightToolbarLayout.Toolbar>
      </RightToolbarLayout>
    </div>
  );
}
